import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/intro",
    name: "intro",
    component: () =>
      import(/* webpackChunkName: "page-intro" */ "../views/IntroView.vue"),
  },
  {
    path: "/material",
    name: "material",
    component: () =>
      import(
        /* webpackChunkName: "page-material" */ "../views/MaterialView.vue"
      ),
  },
  {
    path: "/data",
    name: "data",
    component: () =>
      import(/* webpackChunkName: "page-data" */ "../views/DataView.vue"),
  },
  {
    path: "/design",
    name: "design",
    component: () =>
      import(/* webpackChunkName: "page-design" */ "../views/DesignView.vue"),
  },
  {
    path: "/literature",
    name: "literature",
    component: () =>
      import(
        /* webpackChunkName: "page-literature" */ "../views/LiteratureView.vue"
      ),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});

// 添加路由预加载策略（优化用户体验）
router.beforeEach((to, from, next) => {
  // 定义预加载映射关系
  const preloadMap = {
    "/": ["intro", "material"],
    "/intro": ["material", "data"],
    "/material": ["data", "design"],
    "/data": ["design", "literature"],
    "/design": ["literature"],
  };

  // 预加载可能访问的页面
  const routesToPreload = preloadMap[from.path] || [];
  routesToPreload.forEach((routeName) => {
    const route = routes.find((r) => r.name === routeName);
    if (route && typeof route.component === "function") {
      // 延迟预加载，避免阻塞当前导航
      setTimeout(() => {
        route.component().catch(() => {
          // 预加载失败时静默处理
        });
      }, 50);
    }
  });

  next();
});

export default router;
